// ==============================================
// FAQ Page - Accordion and Navigation functionality
// ==============================================

function toggleFaq(item) {
    const wasOpen = item.classList.contains('open');
    // Close all in same category
    item.parentElement.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
}

// Make it available globally for onclick handlers
window.toggleFaq = toggleFaq;

// Anchor navigation with scroll highlighting
document.addEventListener('DOMContentLoaded', function() {
    const faqNav = document.getElementById('faq-nav');
    if (!faqNav) return;

    const categories = document.querySelectorAll('.faq-category');
    const navItems = document.querySelectorAll('.faq-nav-item');

    // Smooth scroll to category on nav click
    navItems.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                // Update active state immediately
                navItems.forEach(n => n.classList.remove('active'));
                this.classList.add('active');
            }
        });
    });

    // Highlight active nav on scroll
    let ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                let current = '';
                categories.forEach(cat => {
                    const top = cat.offsetTop - 80;
                    if (window.scrollY >= top) {
                        current = cat.id;
                    }
                });
                navItems.forEach(n => {
                    n.classList.toggle('active', n.getAttribute('href') === '#' + current);
                });
                ticking = false;
            });
            ticking = true;
        }
    });
});
